import { checkContrast } from "../ColorPicker";
export const iconButtonForColorToolSxProps = {
    padding: "6px",
    "& svg": {
        height: "24px",
        width: "24px"
    }
};
export const TRANSPARENT_COLOR = "transparent";
export const getIconColor = (color, iconColor) => {
    if (color == null) {
        return iconColor;
    }
    return color === TRANSPARENT_COLOR || checkContrast(color, "#ffffff") <= 3
        ? iconColor
        : "white";
};
export const getIconAbsoluteColor = (color, theme, iconColor) => {
    const absoluteColor = getIconColor(color, iconColor);
    return absoluteColor === "primary" ? theme.palette.primary.main :
        absoluteColor === "default" ? theme.palette.action.active :
            absoluteColor;
};
//# sourceMappingURL=utils.js.map